<template lang="pug">
  .component-reveal-void
    ModalReveal
      button.button.danger(slot="trigger") Usage details
      .header(slot="header")
        h2  CR{{item.id}}&nbsp;
        h4 {{item.reason}}

        Cards(:data="creditData")
      base-list(:component="component", :data-loader="dataLoader", componentType="usages")
</template>
<script type="text/babel">
import ModalReveal from '../../../foundation/ModalReveal'
import InputSwitch from '../../InputSwitch'
import ActionButton from '../../ActionButton'
import Transaction from '../../../../backoffice/Transaction'
import BaseList from '../../../../../pages/backoffice/BaseList'
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import Cards from '../../../Cards'

export default {
  name: 'CreditRecordUsageReveal',
  components: {Cards, BaseList, Transaction, ActionButton, InputSwitch, ModalReveal},
  data() {
    return {
      component: require('../../../../backoffice/CreditRecord'),
      items: [],
      loaded: false
    }
  },
  created() {
  },

  methods: {
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.credits.usages(this.item.id, page, resultsPerPage, (data) => {
        this.items = data.items
        this.loaded = true
        callback(data)
      })
    }
  },
  computed: {
    creditData() {
      let left = '--'

      if (this.loaded) {
        left = 0
        this.items.forEach((item => {
          left += item.amount
        }))
        left = this.$priceWithcurrency(this.item.amount + left)
      }


      return [
        {
          title: 'Amount',
          value: this.$priceWithcurrency(this.item.amount)
        },
        {
          title: 'Amount Left',
          value: left
        },

      ]
    }
  },

  props: ['buttons', 'item'],
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-reveal-void
  .modal-footer
    .footer
      display: flex
      justify-content: space-around
</style>



// WEBPACK FOOTER //
// CrediRecordUsageReveal.vue?5fc627bc